var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import Highlighter from "react-highlight-words";
import ClickOut from 'react-click-out';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import localesReplacement from '../../utils/localesReplacement';
var cx = classnames.bind(style);
function FilterDropdown(props) {
    var ref = useRef(null);
    var dataList = props.dataList, filter = props.filter, changeHandler = props.changeHandler, type = props.type, replacements = props.replacements;
    var _a = useState(false), visible = _a[0], setVisible = _a[1];
    var _b = useState(''), textFilter = _b[0], setTextFilter = _b[1];
    useEffect(function () {
        if (!filter) {
            setTextFilter('');
        }
    }, [dataList === null || dataList === void 0 ? void 0 : dataList.length]);
    var handleKeyDown = function (event) {
        var key = event.key, keyCode = event.keyCode;
        if (dataList && 'length' in dataList && (dataList === null || dataList === void 0 ? void 0 : dataList.length) <= 1) {
            return;
        }
        // Ignore tab, alt
        var ignoreKeyCodes = [9, 13, 16, 17, 18, 19, 20, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46];
        if (ignoreKeyCodes.includes(keyCode) || keyCode > 91) { // Ignore function keys etc
            return;
        }
        // ESC
        else if (keyCode === 27) {
            setTextFilter('');
        }
        // Backspace
        else if (keyCode === 8) {
            setTextFilter(textFilter.slice(0, -1));
        }
        else {
            if (key.length === 1) {
                setTextFilter(textFilter.concat(key));
            }
        }
    };
    var filterFn = function (item) {
        var searchTokens = textFilter.split(' ');
        if (typeof (item) === 'string') {
            if (searchTokens.length === 1) {
                return item.toLowerCase().search(textFilter.toLowerCase()) >= 0;
            }
            else {
                return searchTokens.every(function (token) { return item.toLowerCase().search(token.toLowerCase()) >= 0; });
            }
        }
        else if (item && 'name' in item) {
            if (searchTokens.length === 1) {
                return item.name.toLowerCase().search(textFilter.toLowerCase()) >= 0;
            }
            else {
                return searchTokens.every(function (token) { return item.name.toLowerCase().search(token.toLowerCase()) >= 0; });
            }
        }
        else {
            return item;
        }
    };
    var toggle = function () {
        !_.isEmpty(dataList) && setVisible(!visible);
    };
    var setClickOutState = function () {
        setVisible(false);
    };
    var applyHandler = function (value) {
        setTextFilter('');
        changeHandler(value);
        setVisible(false);
    };
    var clear = function (evt) {
        setTextFilter('');
        if (filter) {
            changeHandler('');
            setVisible(false);
        }
        else {
            ref.current.focus();
        }
        evt.stopPropagation();
    };
    return (_jsx(ClickOut, __assign({ className: 'click-out', onClickOut: setClickOutState }, { children: _jsxs("div", __assign({ ref: ref, tabIndex: 0, onKeyDown: handleKeyDown, className: cx('filter-dropdown', {
                open: visible,
                disabled: _.isEmpty(dataList),
            }) }, { children: [_jsx("div", __assign({ className: cx('block'), onClick: toggle }, { children: _jsxs("div", __assign({ className: cx('meta') }, { children: [_jsx("span", __assign({ className: cx('label') }, { children: type }), void 0), _jsx("span", __assign({ className: cx('note') }, { children: _.isEmpty(filter || textFilter)
                                    ? localesReplacement(replacements, '-- Search or choose --')
                                    : textFilter || filter }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: cx('dropdown') }, { children: [_jsx("ul", __assign({ className: cx('options') }, { children: _.chain(dataList)
                                .filter(filterFn)
                                .map(function (data, index) { return (_jsx("li", __assign({ className: cx({
                                    actived: _.isEqual(filter, _.isString(data) ? data : data === null || data === void 0 ? void 0 : data.name),
                                }), onClick: function () {
                                    return applyHandler(_.isString(data) ? data : data['name']);
                                }, title: _.isString(data) ? data : _.get(data, 'name', '') }, { children: _jsx(Highlighter, { highlightClassName: cx('highlight'), searchWords: textFilter.split(' '), autoEscape: true, textToHighlight: _.isString(data) ? data : _.get(data, 'name', '') }, void 0) }), index)); })
                                .value() }), void 0), !_.isEmpty(filter || textFilter) && (_jsx("button", __assign({ className: cx('apply-btn'), onClick: clear }, { children: localesReplacement(replacements, 'Remove filters') }), void 0))] }), void 0)] }), void 0) }), void 0));
}
export default FilterDropdown;
